export function copySelectedTasks({ store }) {
    store.eachSelected((id, index) => {
        store.in.exec("copy-task", {
            id,
            join: !!index,
        });
    }, true);
}
//# sourceMappingURL=copy.js.map